// components/BasicModal.js
import React, { useRef, useEffect, useState  } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { isValid } from "@/lib/utils";
import { useContactUsMutation } from "@/redux/apiSlices/formApi";
import emailjs from "emailjs-com"; // ✅ Import emailjs
import CustomInput from "@/components/ui/customInput";
import { Input } from "@/components/ui/input";
import { validationRules } from "@/lib/validationRules";
import { useToast } from "@/components/ui/use-toast";
import { Controller, useForm } from "react-hook-form";

export function ReserveNowModal({modelNumber, serialNo, storeAddress, storeEmail}) {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const formRef = useRef(null); // ✅ Create a ref for the form

  const {
    requiredAlphabetOnly,
    phoneNumber,
    email,
  } = validationRules;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset, // ✅ Destructure reset from useForm
  } = useForm({ defaultValues: {} });

  const [contactUs, { data, isSuccess, isLoading: isUserLoading, isError, error: errMsg }] = useContactUsMutation();
  useEffect(() => {
    if (isSuccess) {
      if (data?.success) {
        toast({ title: "The email has been sent successfully." })
      }
    }
    if (isError) {
      toast({
        title: errMsg?.data?.msg,
      });
    }
  }, [isSuccess, isError]);

  const onSubmit = async (data) => {
    if (!formRef.current) return;

    try {
      // const result = await emailjs.sendForm(
      //   "service_p9hikna", // ✅ Replace with your SERVICE_ID
      //   "template_k6z9w9b", // ✅ Replace with your TEMPLATE_ID
      //   formRef.current, // ✅ Ensure formRef is correctly assigned
      //   "fPU1GN_ay2kQqv7LR" // ✅ Replace with your PUBLIC_KEY
      // );

      // toast({ title: "The email has been sent successfully." });
      const subject = `Online Open-Box Product Reservation - ${modelNumber || "N/A"} / ${serialNo || "N/A"} / ${storeAddress || "N/A"}`;
      const formType=`Open-Box Reserve Form`;
      const OpenBoxName =`${data.first_name} ${data.last_name}`;
      const openBoxItemName=`${modelNumber}`;
      const serialNumber=`${serialNo}`;
      const storeEmailAddress =`${storeEmail}`;
      const storeLocation=`${storeAddress}`;
      // const description  = `<p>You have received a new request from <span style="color:#FF991F;" >${data.first_name} ${data.last_name}</span> to reserve <span style="color:#008DA6;">${modelNumber}</span> / <span style="color:#36B37E">${serialNo}</span> in <span style="color:#403294">${storeAddress}</span>. Please reach out to the customer for further assistance regarding this open-box item.</p>`
      const description  = `<p>You have received a new request from <span style="color:#FF991F;" >${data.first_name} ${data.last_name}</span> to regarding <span style="color:#008DA6;">${modelNumber}</span> / <span style="color:#36B37E">${serialNo}</span> in <span style="color:#403294">${storeAddress}</span>. Please reach out to the customer for further assistance regarding this open-box item.</p>`
      const formData = { ...data, subject, serialNumber, OpenBoxName, storeEmailAddress,openBoxItemName, storeLocation, description, formType };

      await contactUs(formData);
      setOpen(false)
      reset(); // ✅ Reset form fields after successful submission
    } catch (error) {
      console.error("❌ Error sending email:", error);

      toast({
        title: "Failed to send email. Please try again later.",
      });
    }
  };
  
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {/* <Button className="  px-[18px] h-[44px] rounded-10 bg-blue1 border-blue1 text-white border">
          Reserve Now
        </Button> */}
      </DialogTrigger>
      <DialogContent className="max-w-[610px] rounded-[20px] py-5 px-[66px] smd:px-[40px] ">
        <DialogHeader>
          <DialogTitle className=" text-[30px] font-medium text-blue1 leading-[44px] text-start pb-[10px]">
            Reserve Now
          </DialogTitle>
          <DialogDescription className="m-0">
            <p className=" font-medium text-[14px] leading-[21px] text-blue1 text-left pb-6">
              By reserving this product, this item will be placed on hold for
              48-hours at its respective store location. Failure to pickup
              within 48-hours will result in loss of reservation. Payment will
              be made upon pickup*
            </p>
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className="max-h-[calc(100vh-325px)] overflow-auto">
              <div>
                <div className="grid grid-cols-2 gap-x-5 mob:grid-cols-1">
                  <input 
                    type="hidden" 
                    name="subject" 
                    //value={`Online Open-Box Product Reservation - ${modelNumber || "N/A"} / ${serialNo || "N/A"} / ${storeAddress || "N/A"}`}  
  //                   defaultValue={`Reservation - [${modelNumber || "N/A"} - ${serialNo || "N/A"}] / [${storeAddress || "N/A"}]`
  // .replace(/&#x2F;/g, "/")}
                  />

                  <Controller
                    name="first_name"
                    control={control}
                    className={"mb-0"}
                    rules={requiredAlphabetOnly("First Name")}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="First Name*"                       
                        maxLength={25}
                        isInvalid={errors.first_name}
                        capitalizeFirst
                        errorMessage={errors.first_name?.message}
                        {...field}
                      />
                    )}
                  />

                  <Controller
                    name="last_name"
                    control={control}
                    rules={requiredAlphabetOnly("Last Name")}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="Last Name*"
                        maxLength={25}
                        isInvalid={errors.last_name}
                        capitalizeFirst
                        errorMessage={errors.last_name?.message}
                        {...field}
                      />
                    )}
                  />
                </div>

                 <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Please enter email ",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Please enter valid email",
                      },
                    }}
                    render={({ field }) => (
                      <CustomInput
                        label="Email"
                        maxLength={1000}
                        isInvalid={isValid("email", errors)}
                        errorMessage="Please enter valid email"
                        {...field}
                      />
                    )}
                  />

                <Controller
                  name="address"
                  control={control}
                  rules={{
                    required: "Street line is required",
                  }}
                  render={({ field }) => (
                    <CustomInput
                      labelClassName="bg-white"
                      placeholder="Street Line Address*"
                      maxLength={1000}
                      isInvalid={errors.address}
                      errorMessage={errors.address?.message}
                      {...field}
                    />
                  )}
                />
                {/* <Input
                  placeholder="Street Line Address*"
                  className="h-11 rounded-[10px] border-gray15"
                /> */}
                 <Controller
                    name="address2"
                    control={control}
                    // rules={{
                    //   required: "Form Input is requiring a 2nd address",
                    // }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        placeholder="Street Line Address 2"
                        maxLength={1000}
                        isInvalid={errors.address2}
                        errorMessage={errors.address2?.message}
                        {...field}
                      />
                    )}
                  />
                <div className="grid grid-cols-2 gap-x-5 mob:grid-cols-1">
                  <Controller
                    name="state"
                    control={control}
                    rules={{
                      required: "State/Province is required",
                    }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        placeholder="State/Province*"
                        maxLength={1000}
                        isInvalid={errors.state}
                        errorMessage={errors.state?.message}
                        {...field}
                      />
                    )}
                  />

                  <Controller
                    name="city"
                    control={control}
                    rules={{
                      required: "city is required",
                    }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        placeholder="City*"
                        maxLength={1000}
                        isInvalid={errors.city}
                        errorMessage={errors.city?.message}
                        {...field}
                      />
                    )}
                  />
                </div>
                <div className="grid grid-cols-2 gap-x-5 mob:grid-cols-1">
                  {/* <Input
                    placeholder="Zip/Postal Code*"
                    className="h-11 rounded-[10px] border-gray15"
                  /> */}

                  <Controller
                    name="zipcode"
                    control={control}
                    rules={{
                      required: "Zip code is required",
                      pattern: {
                        value: /^[0-9]{5}$/,
                        message: "Invalid zip code format",
                      },
                    }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        placeholder="Zip/Postal Code*"
                        maxLength={5}
                        isInvalid={errors.zipcode}
                        errorMessage={errors.zipcode?.message}
                        {...field}
                      />
                    )}
                  />
                   <Controller
                    name="mobile"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) => value.trim() !== "" || "Only spaces are not allowed",
                      pattern: {
                        value: /^[0-9]+$/, // Only numbers
                        message: "Phone number must contain only digits",
                      },
                      minLength: {
                        value: 10, // Adjust based on your needs
                        message: "Please enter a valid 10-digit",
                      },
                      maxLength: {
                        value: 10, // Adjust based on your needs
                        message: "Please enter a valid 10-digit",
                      },
                    }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="Phone Number*"
                        isInvalid={isValid("mobile", errors)}
                        errorMessage={errors.mobile?.message}
                        {...field}
                      />
                    )}
                  />
                </div>
                <div className="flex space-x-4 justify-end">
                  <Button type="submit"
                   className=" w-full max-w-[172px] px-[18px] h-[44px] hover:bg-inherit rounded-10 text-blue1 border-blue1 bg-white border ">
                    Reserve Now
                  </Button>
                </div>
              </div>
            </form>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-start"></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
